import { CORREOS_PSICO } from '@leadsphere/types';

function CxcIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="3" width="20" height="14" rx="2" />
      <path d="M8 21h8M12 17v4" />
    </svg>
  );
}

function AusenciasIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 2v4M16 2v4M3 10h18" />
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M9 16l2 2 4-4" />
    </svg>
  );
}

function AprobacionAusenciasIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <path d="M22 4L12 14.01l-3-3" />
    </svg>
  );
}

function ReportesIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 3v18h18" />
      <path d="M18 17V9M13 17V5M8 17v-3" />
    </svg>
  );
}

function ClientesIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

function SecretosIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );
}

function CatalogosIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  );
}

function DiasFestivosIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
  );
}

function TiposAusenciaIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6M9 13h6M9 17h6" />
    </svg>
  );
}

function UsuariosIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="4" />
      <path d="M3 20a9 9 0 0 1 18 0" />
    </svg>
  );
}

function SeguimientosIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 11l3 3L22 4" />
      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
    </svg>
  );
}

function TicketsIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 5v2M15 11v2M15 17v2M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 0 0 0-4V7a2 2 0 0 1 2-2z" />
    </svg>
  );
}

function AniosServicioIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6v6l4 2" />
    </svg>
  );
}

function DashboardIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" />
      <rect x="14" y="3" width="7" height="7" />
      <rect x="3" y="14" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" />
    </svg>
  );
}

function AspirantesIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M19 8v6M22 11h-6" />
    </svg>
  );
}

export interface NavItemDef {
  to: string;
  label: string;
  end: boolean;
  Icon: () => JSX.Element;
  // Si se omite, el link es visible para cualquier rol autenticado.
  roles?: string[];
  // Acceso adicional por correo específico (OR con roles).
  // Si tiene roles Y correos, el ítem es visible si cumple cualquiera de los dos.
  correos?: string[];
  // Override del cálculo de "activo" — necesario para Tickets: debe seguir
  // resaltado en /tickets/:id (detalle) pero NO en /tickets/dashboard, que
  // es un nav-item hermano propio. NavLink `end` por sí solo no distingue eso.
  isActive?: (pathname: string) => boolean;
  // Visible en el sidebar pero sin navegación — entrada "próximamente" que se
  // habilitará cuando exista la página correspondiente (siguiente prompt).
  disabled?: boolean;
}

export interface NavGroup {
  label: string;
  items: NavItemDef[];
}

// Grupos y orden — diseño aprobado 2026-08-07 (BG-9).
// Este orden también es la fuente de verdad para "primera ruta accesible por
// rol" (ver getFirstAccessibleRoute) — RequireRol la usa como fallback cuando
// hay sesión válida pero el rol no tiene permiso para la ruta pedida.
export const NAV_GROUPS: NavGroup[] = [
  {
    label: 'Principal',
    items: [
      { to: '/cxc', label: 'CxC', end: false, Icon: CxcIcon },
      { to: '/reportes', label: 'Reportes', end: false, Icon: ReportesIcon, roles: ['root', 'head', 'analista', 'kam', 'ads_manager', 'gerente_comercial', 'comercial', 'CEO'] },
    ],
  },
  {
    label: 'RH',
    items: [
      // Prompt AF(RH) — visible a cualquier autenticado, sin roles=: cualquier
      // empleado puede solicitar ausencias, y aprobador_permisos_id puede ser
      // cualquiera sin importar su rol.
      { to: '/ausencias', label: 'Ausencias', end: false, Icon: AusenciasIcon },
      { to: '/aprobacion-ausencias', label: 'Aprobar Ausencias', end: false, Icon: AprobacionAusenciasIcon },
      // Prompt BB-4(RH) — visible a todos, sin roles=.
      { to: '/anios-servicio', label: 'Años de Servicio', end: false, Icon: AniosServicioIcon },
      // Prompt BB-3(RH) — renombrado a "Team". Solo root/CEO (SRS-01 §9.1).
      { to: '/usuarios', label: 'Team', end: false, Icon: UsuariosIcon, roles: ['root', 'CEO'] },
      // Prompt AC — módulo de RH/Vacaciones. Solo root/head.
      { to: '/dias-festivos', label: 'Días Festivos', end: false, Icon: DiasFestivosIcon, roles: ['root', 'head'] },
      // Prompt AD — segunda pieza del motor de vacaciones.
      { to: '/tipos-ausencia', label: 'Tipos de Ausencia', end: false, Icon: TiposAusenciaIcon, roles: ['root', 'head'] },
      // Panel de Aspirantes. Solo root o CORREOS_PSICO (Vero y Yael).
      // roles=['root'] cubre root; correos cubre a las personas con rol head.
      { to: '/aspirantes', label: 'Aspirantes', end: false, Icon: AspirantesIcon, roles: ['root'], correos: [...CORREOS_PSICO] },
    ],
  },
  {
    label: 'Gestión',
    items: [
      { to: '/clientes', label: 'Clientes', end: false, Icon: ClientesIcon },
      // root/head/analista gestionan catálogos; kam/comercial entran solo para
      // gestionar Áreas y ven el resto en solo lectura. CEO en solo lectura.
      { to: '/catalogos', label: 'Catálogos', end: false, Icon: CatalogosIcon, roles: ['root', 'head', 'analista', 'kam', 'ads_manager', 'gerente_comercial', 'comercial', 'CEO'] },
      // Fase 3b: asignación de secrets de GCP a cliente × Amazon × mercado. Solo root.
      { to: '/secretos', label: 'Secretos', end: false, Icon: SecretosIcon, roles: ['root'] },
    ],
  },
  {
    label: 'Operaciones',
    items: [
      // root/head/analista/kam/CEO ven todos los seguimientos. Comercial/digital sin acceso.
      { to: '/seguimientos', label: 'Estado permisos', end: false, Icon: SeguimientosIcon, roles: ['root', 'head', 'analista', 'kam', 'ads_manager', 'gerente_comercial', 'CEO'] },
      {
        to: '/tickets',
        label: 'Tickets',
        end: true,
        Icon: TicketsIcon,
        isActive: pathname => pathname === '/tickets' || (pathname.startsWith('/tickets/') && !pathname.startsWith('/tickets/dashboard')),
      },
      { to: '/tickets/dashboard', label: 'Dashboard', end: false, Icon: DashboardIcon },
    ],
  },
];

// Parte B — primer ítem del sidebar (mismo orden en que aparece el menú) al
// que el rol dado sí tiene acceso. Usado por RequireRol cuando hay sesión
// válida pero sin permiso para la ruta pedida directamente por URL.
export function getFirstAccessibleRoute(rol: string | undefined): string {
  const flatItems = NAV_GROUPS.flatMap(group => group.items);
  const match = flatItems.find(item => !item.disabled && (!item.roles || (rol !== undefined && item.roles.includes(rol))));
  return match?.to ?? '/clientes';
}
